import React from "react";
import styled from "styled-components";
import AdminNavbar from "./AdminNavbar";

export default function AdminLayout({ children }) {
  return (
    <Layout>
      <AdminNavbar />
      <Content>{children}</Content>
    </Layout>
  );
}

const Layout = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 100%);
  padding-top: 80px; /* space for fixed navbar */
`;

const Content = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
`;